import { Permission, PermissionDefinition, RolePermissions, UserRole } from '../types';

// Tüm yetki tanımları
export const permissionDefinitions: PermissionDefinition[] = [
  // Admin yetkileri
  {
    id: Permission.USER_MANAGEMENT,
    name: 'Kullanıcı Yönetimi',
    description: 'Kullanıcıları oluşturma, düzenleme ve silme',
    category: 'Sistem Yönetimi',
    isDangerous: true
  },
  {
    id: Permission.SYSTEM_SETTINGS,
    name: 'Sistem Ayarları',
    description: 'Sistem genel ayarlarını yönetme',
    category: 'Sistem Yönetimi',
    isDangerous: true
  },
  {
    id: Permission.ALL_REPORTS_VIEW,
    name: 'Tüm Raporları Görme',
    description: 'Tüm kullanıcıların raporlarını görme',
    category: 'Rapor Yönetimi',
    isDangerous: false
  },
  {
    id: Permission.ALL_REPORTS_CREATE,
    name: 'Tüm Raporları Oluşturma',
    description: 'Tüm rapor türlerini oluşturma',
    category: 'Rapor Yönetimi',
    isDangerous: false
  },

  // Developer yetkileri
  {
    id: Permission.PAGE_EDITING,
    name: 'Sayfa Düzenleme',
    description: 'Sayfa içeriklerini düzenleme',
    category: 'Geliştirici',
    isDangerous: false
  },
  {
    id: Permission.CSS_EDITING,
    name: 'CSS Düzenleme',
    description: 'Sayfa stillerini düzenleme',
    category: 'Geliştirici',
    isDangerous: false
  },
  {
    id: Permission.SIDEBAR_MANAGEMENT,
    name: 'Sidebar Yönetimi',
    description: 'Sidebar menü öğelerini yönetme',
    category: 'Geliştirici',
    isDangerous: false
  },

  // Mod yetkileri
  {
    id: Permission.CONTENT_MODERATION,
    name: 'İçerik Moderasyonu',
    description: 'Kullanıcı içeriklerini moderasyon',
    category: 'Moderasyon',
    isDangerous: false
  },
  {
    id: Permission.USER_SUPPORT,
    name: 'Kullanıcı Desteği',
    description: 'Kullanıcılara destek sağlama',
    category: 'Moderasyon',
    isDangerous: false
  },

  // Call yetkileri
  {
    id: Permission.CALL_REPORTS,
    name: 'Call Raporları',
    description: 'Call raporlarını oluşturma ve görme',
    category: 'Call Yönetimi',
    isDangerous: false
  },
  {
    id: Permission.CALL_MANAGEMENT,
    name: 'Call Yönetimi',
    description: 'Call ekibini yönetme',
    category: 'Call Yönetimi',
    isDangerous: true
  },
  {
    id: Permission.CALL_ANALYTICS,
    name: 'Call Analitikleri',
    description: 'Call performans analizleri',
    category: 'Call Yönetimi',
    isDangerous: false
  },

  // LiveChat yetkileri
  {
    id: Permission.LIVECHAT_REPORTS,
    name: 'LiveChat Raporları',
    description: 'LiveChat raporlarını oluşturma ve görme',
    category: 'LiveChat Yönetimi',
    isDangerous: false
  },
  {
    id: Permission.LIVECHAT_MANAGEMENT,
    name: 'LiveChat Yönetimi',
    description: 'LiveChat ekibini yönetme',
    category: 'LiveChat Yönetimi',
    isDangerous: true
  },
  {
    id: Permission.LIVECHAT_ANALYTICS,
    name: 'LiveChat Analitikleri',
    description: 'LiveChat performans analizleri',
    category: 'LiveChat Yönetimi',
    isDangerous: false
  },

  // Risk yetkileri
  {
    id: Permission.RISK_REPORTS,
    name: 'Risk Raporları',
    description: 'Risk raporlarını oluşturma ve görme',
    category: 'Risk Yönetimi',
    isDangerous: false
  },
  {
    id: Permission.RISK_MANAGEMENT,
    name: 'Risk Yönetimi',
    description: 'Risk ekibini yönetme',
    category: 'Risk Yönetimi',
    isDangerous: true
  },
  {
    id: Permission.RISK_ANALYTICS,
    name: 'Risk Analitikleri',
    description: 'Risk performans analizleri',
    category: 'Risk Yönetimi',
    isDangerous: false
  },

  // Chat yetkileri
  {
    id: Permission.CHAT_CREATE_GROUPS,
    name: 'Chat Grup Oluşturma',
    description: 'Canlı chat grupları oluşturma',
    category: 'Chat Yönetimi',
    isDangerous: false
  },
  {
    id: Permission.CHAT_MANAGE_GROUPS,
    name: 'Chat Grup Yönetimi',
    description: 'Chat gruplarını yönetme (kullanıcı ekleme/çıkarma)',
    category: 'Chat Yönetimi',
    isDangerous: true
  },
  {
    id: Permission.CHAT_SEND_MESSAGES,
    name: 'Chat Mesaj Gönderme',
    description: 'Canlı chat mesajları gönderme',
    category: 'Chat Yönetimi',
    isDangerous: false
  },

  // Rapor yetkileri
  {
    id: Permission.DAILY_REPORTS,
    name: 'Günlük Raporlar',
    description: 'Günlük raporları oluşturma ve görme',
    category: 'Rapor Yönetimi',
    isDangerous: false
  },
  {
    id: Permission.MONTHLY_REPORTS,
    name: 'Aylık Raporlar',
    description: 'Aylık raporları oluşturma ve görme',
    category: 'Rapor Yönetimi',
    isDangerous: false
  },
  {
    id: Permission.SALES_REPORTS,
    name: 'Satış Raporları',
    description: 'Satış raporlarını oluşturma ve görme',
    category: 'Rapor Yönetimi',
    isDangerous: false
  },
  {
    id: Permission.HOURLY_REPORTS,
    name: 'Saatlik Raporlar',
    description: 'Saatlik raporları oluşturma ve görme',
    category: 'Rapor Yönetimi',
    isDangerous: false
  },
  {
    id: Permission.WORK_SUMMARY_REPORTS,
    name: 'Mesai Özet Raporları',
    description: 'Mesai özet raporlarını oluşturma ve görme',
    category: 'Rapor Yönetimi',
    isDangerous: false
  },
  {
    id: Permission.WEEKLY_REPORTS,
    name: 'Haftalık Raporlar',
    description: 'Haftalık raporları oluşturma ve görme',
    category: 'Rapor Yönetimi',
    isDangerous: false
  },

  // Mesai takibi
  {
    id: Permission.WORK_TIME_TRACKING,
    name: 'Mesai Takibi',
    description: 'Mesai giriş/çıkış yapma',
    category: 'Mesai Yönetimi',
    isDangerous: false
  },
  {
    id: Permission.WORK_TIME_VIEW,
    name: 'Mesai Görüntüleme',
    description: 'Mesai kayıtlarını görme',
    category: 'Mesai Yönetimi',
    isDangerous: false
  },
  
  // Panel ayarları
  {
    id: Permission.PANEL_SETTINGS,
    name: 'Panel Ayarları',
    description: 'Panel URL ve ayarlarını yönetme',
    category: 'Sistem Yönetimi',
    isDangerous: true
  }
];

// Varsayılan rol-yetki eşleştirmeleri
export const defaultRolePermissions: RolePermissions[] = [
  {
    role: UserRole.ADMIN,
    name: 'Admin',
    description: 'Tüm yetkilere sahip',
    permissions: Object.values(Permission) // Admin tüm yetkilere sahip
  },
  {
    role: UserRole.DEVELOPER,
    name: 'Developer',
    description: 'Sayfa düzenleme ve CSS yetkileri',
    permissions: [
      Permission.PAGE_EDITING,
      Permission.CSS_EDITING,
      Permission.SIDEBAR_MANAGEMENT,
      Permission.CHAT_SEND_MESSAGES,
      Permission.DAILY_REPORTS,
      Permission.WORK_TIME_TRACKING,
      Permission.WORK_TIME_VIEW
    ]
  },
  {
    role: UserRole.MOD,
    name: 'Mod',
    description: 'Developer alt yetkisi',
    permissions: [
      Permission.CONTENT_MODERATION,
      Permission.USER_SUPPORT,
      Permission.CHAT_SEND_MESSAGES,
      Permission.DAILY_REPORTS,
      Permission.WORK_TIME_TRACKING,
      Permission.WORK_TIME_VIEW
    ]
  },
  {
    role: UserRole.CALL_ADMIN,
    name: 'Call Admin',
    description: 'Call ekibi yönetimi',
    permissions: [
      Permission.CALL_REPORTS,
      Permission.CALL_MANAGEMENT,
      Permission.CALL_ANALYTICS,
      Permission.CHAT_SEND_MESSAGES,
      Permission.DAILY_REPORTS,
      Permission.WORK_TIME_TRACKING,
      Permission.WORK_TIME_VIEW
    ]
  },
  {
    role: UserRole.CALL,
    name: 'Call',
    description: 'Call işlemleri',
    permissions: [
      Permission.CALL_REPORTS,
      Permission.CHAT_SEND_MESSAGES,
      Permission.DAILY_REPORTS,
      Permission.WORK_TIME_TRACKING,
      Permission.WORK_TIME_VIEW
    ]
  },
  {
    role: UserRole.LIVECHAT_ADMIN,
    name: 'LiveChat Admin',
    description: 'LiveChat ekibi yönetimi',
    permissions: [
      Permission.LIVECHAT_REPORTS,
      Permission.LIVECHAT_MANAGEMENT,
      Permission.LIVECHAT_ANALYTICS,
      Permission.CHAT_SEND_MESSAGES,
      Permission.DAILY_REPORTS,
      Permission.WORK_TIME_TRACKING,
      Permission.WORK_TIME_VIEW
    ]
  },
  {
    role: UserRole.LIVECHAT,
    name: 'LiveChat',
    description: 'LiveChat işlemleri',
    permissions: [
      Permission.LIVECHAT_REPORTS,
      Permission.CHAT_SEND_MESSAGES,
      Permission.DAILY_REPORTS,
      Permission.WORK_TIME_TRACKING,
      Permission.WORK_TIME_VIEW
    ]
  },
  {
    role: UserRole.RISK_ADMIN,
    name: 'Risk Admin',
    description: 'Risk ekibi yönetimi',
    permissions: [
      Permission.RISK_REPORTS,
      Permission.RISK_MANAGEMENT,
      Permission.RISK_ANALYTICS,
      Permission.CHAT_SEND_MESSAGES,
      Permission.HOURLY_REPORTS,
      Permission.WORK_SUMMARY_REPORTS,
      Permission.WORK_TIME_TRACKING,
      Permission.WORK_TIME_VIEW
    ]
  },
  {
    role: UserRole.RISK,
    name: 'Risk',
    description: 'Risk işlemleri',
    permissions: [
      Permission.RISK_REPORTS,
      Permission.CHAT_SEND_MESSAGES,
      Permission.HOURLY_REPORTS,
      Permission.WORK_SUMMARY_REPORTS,
      Permission.WORK_TIME_TRACKING,
      Permission.WORK_TIME_VIEW
    ]
  }
];

// Yetki kontrolü fonksiyonları
export const hasPermission = (userPermissions: Permission[], permission: Permission): boolean => {
  return userPermissions.includes(permission);
};

export const hasAnyPermission = (userPermissions: Permission[], permissions: Permission[]): boolean => {
  return permissions.some(permission => userPermissions.includes(permission));
};

export const hasAllPermissions = (userPermissions: Permission[], permissions: Permission[]): boolean => {
  return permissions.every(permission => userPermissions.includes(permission));
};

// Kategoriye göre yetkileri grupla
export const getPermissionsByCategory = (permissions: Permission[]): { [category: string]: Permission[] } => {
  const grouped: { [category: string]: Permission[] } = {};
  
  permissions.forEach(permission => {
    const definition = permissionDefinitions.find(p => p.id === permission);
    if (definition) {
      if (!grouped[definition.category]) {
        grouped[definition.category] = [];
      }
      grouped[definition.category].push(permission);
    }
  });
  
  return grouped;
};

// Rol için varsayılan yetkileri al
export const getDefaultPermissionsForRole = (role: UserRole): Permission[] => {
  const rolePermission = defaultRolePermissions.find(rp => rp.role === role);
  return rolePermission ? rolePermission.permissions : [];
};

// Yetki tanımını al
export const getPermissionDefinition = (permission: Permission): PermissionDefinition | undefined => {
  return permissionDefinitions.find(p => p.id === permission);
};
